import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class PlanningDashboardController extends Controller {
  @service router;
  @service roadmap;
  @service intl;
  @service session;

  // FIXME: why don't we use app structure for this? @indroneelray
  get tabs() {
    return [
      {
        label: this.intl.t('dictionary.overview'),
        route: 'planning.dashboard.overview',
        key: 'overview',
      },
      {
        label: this.intl.t('dictionary.capacity'),
        route: 'planning.dashboard.capacity',
        key: 'capacity',
      },
      {
        label: this.intl.t('dashboards.impact'),
        route: 'planning.dashboard.roi',
        classes: 'uppercase',
        key: 'roi',
      },
      {
        label: this.intl.t('_scenarios.title', {
          num: 1,
        }),
        route: 'planning.dashboard.balance',
        key: 'balance',
      },
    ];
  }

  @action
  isActive(tab) {
    return this.router.currentRouteName.includes(tab.route);
  }
}
